import { render, staticRenderFns } from "./NewFeature.vue?vue&type=template&id=1b6047ec&scoped=true"
import script from "./NewFeature.vue?vue&type=script&lang=js"
export * from "./NewFeature.vue?vue&type=script&lang=js"
import style0 from "./NewFeature.vue?vue&type=style&index=0&id=1b6047ec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6047ec",
  null
  
)

export default component.exports